// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"34ab28d2","97":"c39c6748","138":"7f339881","398":"c39c6748","479":"1f3aef30","584":"2f721491","663":"f69466b8","964":"34ab28d2"}[chunkId] + ".chunk.css";
};